import './register.css'
// import { Switch, Route, Link} from 'react-router-dom';
import {
    Container,
    Form,
    Col,
    Row,
    Button,
} from "react-bootstrap";
// import axios from 'axios';
import React from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import 'bs-stepper/dist/css/bs-stepper.min.css';
// import Stepper from 'bs-stepper'
// import Stepper from 'react-stepper-horizontal';
import ReactGA from 'react-ga';

export default function RegisterUser(props) {
    ReactGA.pageview(window.location.pathname + window.location.search);    
    const bookingData = props.location.state.bookingData;

    const {register, handleSubmit} = useForm();
    let history = useHistory();

    const onSubmit = async (data) => {
        bookingData.customer_name = data.name;
        bookingData.customer_email = data.email;
        bookingData.customer_message = data.message;
        console.log(bookingData)
        history.push({
          pathname: '/booking/review',
          state: { bookingData }
        });
    }
    
        return (
            <Container className='mt-5'>
                <Row>
                    <Col xs={12} md={8} lg={6}>
                        <div className='my-5'>
                            <div id="stepper1" class="bs-stepper">
                                
                                <div class="bs-stepper-header">
                                    <div class="step" data-target="#test-l-1">
                                    <span class="bs-stepper-circle">1</span>
                                    <span class="bs-stepper-label">Time</span>
                                </div>
                                
                                <div class="line"/>

                                <div class="step" data-target="#test-l-2">
                                    <span class="bs-stepper-circle">2</span>
                                    <span class="bs-stepper-label">Register</span>
                                </div>

                                <div class="line"/>

                                <div class="step" data-target="#test-l-3">
                                    <span class="bs-stepper-circle">3</span>
                                    <span class="bs-stepper-label">Review</span>
                                </div>

                                <div class="line"/>

                                <div class="step" data-target="#test-l-4">
                                    <span class="bs-stepper-circle">4</span>
                                    <span class="bs-stepper-label">Confirm</span>
                                </div>

                                </div>
                            </div>
                        </div>

                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Form.Group >
                                <Form.Label>Full Name*</Form.Label>
                                <Form.Control required placeholder="Full Name" name="name" ref={register ({required:true})}/>
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Email address*</Form.Label>
                                <Form.Control required name="email" ref={register ({required:true})} placeholder="Email" />
                            </Form.Group>

   
                            <Form.Group controlId="description">
                                <Form.Label>Message</Form.Label>
                                <Form.Control  as="textarea" rows="3" name="message" placeholder="Feel free to write a message to the clinic or provider." ref={register ()} />
                            </Form.Group> 

                            <Button variant="primary" type="submit">
                                Review Booking
                            </Button>
                        </Form>
    
                    </Col>
                </Row>
            </Container>
        );
      }
    